import React from 'react'
import AddPost from '../Components/Addpost/AddPost'
const AddPostPage = () => {
  return (
    <AddPost />
  )
}

export default AddPostPage